import { useQuery } from '@tanstack/react-query';
import { api } from '../../libs/axios';
import { RelatorioFilter } from './useRelatorio';

export interface RelatorioResumo {
  transacoes: number;
  assentos: number;
  total: number;
  comissao_total?: number;
  comissao_representante?: number;
}

export interface useRelatorioProps {
  filter?: RelatorioFilter;
}

async function getRelatorio({ filter }: useRelatorioProps): Promise<RelatorioResumo> {
  const response = await api
    .get('pedido/resumo', {
      params: {
                ...filter,
      },
    })
    .then((res) => res.data);

  const resumo: RelatorioResumo = response;

  return resumo;
}

export function useRelatorioResumo({ filter }: useRelatorioProps) {
  return useQuery({
    queryKey: ['pedidos-resumo', { filter }],
    queryFn: () => getRelatorio({ filter }),
    staleTime: 1,
    gcTime: 1,
    retry: false,
    refetchOnWindowFocus: false, // Only refetch when the window is not in focus
  });
}
